<template>
    <div class="milady">
        <div class="milady-div">
            <h2> التاريخ الميلادي </h2>
            <h2 name="miladyDate">2-4-2022</h2>
        </div>

        <div class="events">
            <p>
                <span> بداية السنة الهجرية </span>
                <span>2023-07-18</span>
            </p>
            <p>
                <span> عاشوراء </span>
                <span>2023-07-27</span>
            </p>
            <p>
                <span> رمضان </span>
                <span>2024-03-10</span>
            </p>
            <p>
                <span> عيد الفطر </span>
                <span>2024-04-09</span>
            </p>
            <p>
                <span> أول أيام الحج </span>
                <span>2024-06-14</span>
            </p>
            <p>
                <span> يوم عرفة </span>
                <span>2024-06-15</span>
            </p>
            <p>
                <span> عيد الأضحى </span>
                <span>2024-06-16</span>
            </p>
            <p><span> التوقيت الصحيح يعتمد على الرؤية الشرعية </span></p>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            dateM() {
                var date = new Date();
                var d = date.getDate(),
                    m = date.getMonth() + 1,
                    y = date.getFullYear();
                document.querySelector("[name='miladyDate']").innerText = `${y}-${m}-${d} م`;
            }
        },
        mounted() {
            this.dateM();
        }
    }
</script>



